export default __webpack_public_path__ + "static/media/background.17786249.png";